export default __webpack_public_path__ + "static/media/CompararIcon.fe4e1015.svg";